import { render, staticRenderFns } from "./AdminStepCard.vue?vue&type=template&id=54ffb83a&scoped=true&"
import script from "./AdminStepCard.vue?vue&type=script&lang=js&"
export * from "./AdminStepCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminStepCard.vue?vue&type=style&index=0&id=54ffb83a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ffb83a",
  null
  
)

export default component.exports